import React from "react";
import PersonsPage from "@/pages/admin/PersonsPage";

export default function GeneralBody() {
  return (
    <PersonsPage
      bodyType="general_body"
      title="General Body"
      subtitle="Trust membership"
      intro="General body members of GS Mandal — full register with contact, identity, and status."
      prefix="general"
    />
  );
}
